module.exports = __webpack_public_path__ + "assets/img/smart-lane.12e48626.jpg";